
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/br/[tickerSymbol]/events",
      function () {
        return require("private-next-pages/br/[tickerSymbol]/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/br/[tickerSymbol]/events"])
      });
    }
  